import ProductDetail from '../components/ProductDetail/ProductDetail';

const App = () => <ProductDetail />;
export default App;
